export type Attendee = {
 id: string; kind: 'main' | 'partner'; first_name: string; last_name: string;
 dietary_wishes: string; mobility_wishes: string; other_wishes: string; discussion_topics: string;
 same_flight_as_main: boolean; flight_number: string; arrival_date: string | null; arrival_time: string | null;
 departure_flight_number: string; departure_date: string | null; departure_time: string | null; travel_notes: string;
};
export type Term = {
 external_invoice_id?: string | null; invoice_number: string | null; amount_paid: number | null;
 number: number; amount: number | null; request_date: string; due_date: string;
 requested_at: string | null; paid_at: string | null;
};
export type Registration = {
 billing_model?: string; id: string; email: string; first_name: string; last_name: string; partner: boolean;
 status: string; created_at: string; updated_at?: string; review_reason: string | null;
 invoice_number: string | null; invoice_date?: string | null; invoice_sent_at?: string | null;
 amount_excl: number | null; amount_vat?: number | null; amount_due: number | null; amount_paid: number | null;
 vat_regime?: string; paid_installments: number; installment_count: number;
 first_payment_at?: string | null; fully_paid_at?: string | null;
 cancelled_at?: string | null; cancellation_reason: string | null; discussion_topics: string;
 billing_details?: {
  company?: string; vatNumber?: string; street?: string; postcode?: string; city?: string; country?: string;
  gender?: string; terms_acceptance?: { accepted_at?: string; document?: string };
 };
 attendees: Attendee[]; installments: Term[];
 jobs: { action: string; status: string; attempts: number; last_error: string | null }[];
};
export type Overview = { event: { name: string; registration_open: boolean }; registrations: Registration[]; finance: boolean };
export const registrationLabels: Record<string, string> = {
 received: 'In verwerking', review: 'Ter controle', invoiced: 'Gefactureerd', partial: 'Gedeeltelijk betaald', paid: 'Volledig betaald', cancelled: 'Geannuleerd',
};
export function travelFor(registration: Registration, attendee: Attendee) {
 return attendee.kind === 'partner' && attendee.same_flight_as_main
  ? registration.attendees.find(a => a.kind === 'main') : attendee;
}
export function travelRows(registrations: Registration[]) {
 return registrations.flatMap(registration => registration.attendees.map(attendee => ({
  registration, attendee, travel: travelFor(registration, attendee),
  inherited: attendee.kind === 'partner' && attendee.same_flight_as_main,
 }))).sort((a, b) => {
  const key = (row: typeof a) => `${row.travel?.arrival_date || '9999-12-31'} ${row.travel?.arrival_time || '23:59:59'}`;
  return key(a).localeCompare(key(b))
   || a.registration.id.localeCompare(b.registration.id)
   || a.attendee.kind.localeCompare(b.attendee.kind);
 });
}
